import { ReactElement, useEffect } from "react";
import { useDynamicPageMeta } from "../../hooks/useDynamicPageMeta";
import "../../assets/css/disclaimer.css";
import "../../assets/css/staticBannerPage.css";
import PrivacyPolicyBanner from "./components/PrivacyPolicyBanner";
import PrivacyPolicyBody from "./components/PrivacyPolicyBody";

export default function PrivacyPolicyPage(): ReactElement {
  const { setPageMeta, clearPageMeta } = useDynamicPageMeta();

  useEffect(() => {
    document.title = "WSG: Privacy Policy";
    setPageMeta({
      breadcrumbLabels: { "/privacypolicy": "Privacy Policy" },
    });
    return () => {
      clearPageMeta();
    };
  }, [clearPageMeta, setPageMeta]);

  return (
    <div className="disclaimer-page">
      <div className="disclaimer-hero" aria-hidden="true" />
      <PrivacyPolicyBanner />
      <PrivacyPolicyBody />
    </div>
  );
}
